import { IPaginationSetup, TApiOptions } from './defineApi';

type THeaders =
  | HeadersInit
  | (() => HeadersInit)
  ;

interface IConfigOptions {
  apiUrl?: string;
  headers?: THeaders;
  convertCase?: boolean;
  pagination?: IPaginationSetup;
  requestOptions?: TApiOptions;
}

function clearConfig(): void {
  apiConfig = {};
}

function defineConfig(options: IConfigOptions) {
  if (Object.isFrozen(apiConfig)) {
    throw new Error('You can configure Prevue only once.');
  }

  apiConfig.apiUrl = options.apiUrl;
  apiConfig.headers = options.headers;
  apiConfig.convertCase = options.convertCase;
  apiConfig.pagination = options.pagination;
  apiConfig.requestOptions = options.requestOptions;

  apiConfig = Object.freeze(apiConfig);
}

let apiConfig: IConfigOptions = {};

export {
  apiConfig,
  defineConfig,
};

export const configExportsForTesting = {
  clearConfig,
};
